import Component,{register} from '@services/component'
import {isMobile} from '@services/browser'

export default register(
    class ContentTable extends Component {
        static selector = '.contenttable'
        create(){
            const {parentElement} = this.el;
            const wrapper = document.createElement('div');
            wrapper.className='table-container';
            parentElement.insertBefore(wrapper,this.el);
            parentElement.removeChild(this.el);
            wrapper.appendChild(this.el);
            this.wrapper = wrapper;
            if(isMobile){
                this.el.style.display = 'none';
                this.buildMobile();
            }
        }

        buildMobile(){
            const headers = Array.from(this.el.querySelectorAll('th')).map(th => th.textContent);
            const items = Array.from(this.el.querySelectorAll('tbody tr')).map(row => {
                const item = {};
                Array.from(row.querySelectorAll('td')).forEach((col,index) => {
                    if(!headers[index].trim()){
                        item.__headline = col.textContent;
                    }else{
                        item[headers[index].trim()] = col.textContent;
                    }
                });

                return item;
            });

            if(!items.length) return;

            items.forEach(item => {
                const {__headline,...rows} = item;
                const card = document.createElement('div');
                card.className = 'card';
                card.innerHTML = `
                <div class="card-content">
                    <div class="content">
                        ${__headline?`<h5>${__headline}</h5>`:''}
                        ${
                            Object.entries(rows).map(([key,value]) => `<div class="mb-2"><strong>${key}: </strong>${value}</div>`).join('')
                        }
                    </div>
                </div>
                `;
                this.wrapper.appendChild(card);
            })
        }
    }
);